import {
  UserMessage
} from "./chunk-HWMFMBJC.mjs";
import {
  AssistantMessage
} from "./chunk-OZXUB3V7.mjs";
import {
  __objRest
} from "./chunk-MRXNTQOX.mjs";

// src/components/chat/messages/RenderImageMessage.tsx
import { jsx } from "react/jsx-runtime";
function RenderImageMessage(_a) {
  var _b = _a, {
    UserMessage: UserMessage2 = UserMessage,
    AssistantMessage: AssistantMessage2 = AssistantMessage
  } = _b, props = __objRest(_b, [
    "UserMessage",
    "AssistantMessage"
  ]);
  const {
    message,
    inProgress,
    index,
    isCurrentMessage,
    onRegenerate,
    onCopy,
    onThumbsUp,
    onThumbsDown
  } = props;
  if (message.isImageMessage()) {
    const imageData = `data:${message.format};base64,${message.bytes}`;
    const imageComponent = /* @__PURE__ */ jsx("div", { className: "copilotKitImage", children: /* @__PURE__ */ jsx(
      "img",
      {
        src: imageData,
        alt: "User uploaded image",
        style: { maxWidth: "100%", maxHeight: "300px", borderRadius: "8px" }
      }
    ) });
    if (message.role === "user") {
      return /* @__PURE__ */ jsx(
        UserMessage2,
        {
          "data-message-role": "user",
          message: "",
          rawData: message,
          subComponent: imageComponent
        },
        index
      );
    } else if (message.role === "assistant") {
      return /* @__PURE__ */ jsx(
        AssistantMessage2,
        {
          "data-message-role": "assistant",
          message: "",
          rawData: message,
          subComponent: imageComponent,
          isLoading: inProgress && isCurrentMessage && !message.bytes,
          isGenerating: inProgress && isCurrentMessage && !!message.bytes,
          isCurrentMessage,
          onRegenerate: () => onRegenerate == null ? void 0 : onRegenerate(message.id),
          onCopy,
          onThumbsUp,
          onThumbsDown
        },
        index
      );
    }
  }
  return null;
}

export {
  RenderImageMessage
};
//# sourceMappingURL=chunk-SLTG4L62.mjs.map